export default __webpack_public_path__ + "static/media/blank-profile-picture.c3f94521.png";